// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4dc0f069","977":"424de69d"}[chunkId] + ".chunk.js";
};